import type { IconData } from '@stacksjs/iconify-core'

export const scissorsSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M21.5 13a9.46 9.46 0 0 1-1.394 4.957c1.42-.82 3.288-1.867 5.317-2.914c2.181-1.126 4.555-2.257 6.757-3.107c2.186-.844 4.26-1.436 5.82-1.436c4.546 0 6.856 2.662 7.791 4.162c.504.807.024 1.74-.78 2.002C42.145 17.6 33.59 20.47 25.27 24c8.32 3.53 16.875 6.4 19.741 7.336c.804.263 1.284 1.195.78 2.002c-.935 1.5-3.245 4.162-7.791 4.162c-1.56 0-3.634-.592-5.82-1.436c-2.202-.85-4.576-1.981-6.757-3.107a130 130 0 0 1-5.317-2.914A9.5 9.5 0 1 1 6.44 27.297c1.094-.891 2.8-2.035 4.85-3.296c-2.05-1.26-3.756-2.405-4.85-3.296A9.5 9.5 0 1 1 21.5 13m-12 0a2.5 2.5 0 1 1 5 0a2.5 2.5 0 0 1-5 0m0 22a2.5 2.5 0 1 1 5 0a2.5 2.5 0 0 1-5 0\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default scissorsSolid
